import { CascaderOptionType } from 'antd/lib/cascader'
import { GroupedNetworkWithCompaniesWithLegalEntitiesAndCountries } from '../types'

export const transformForAntDesignCascaderNetworkCompanyCountryYear = (
  networkCompanyCountryYearSelector: GroupedNetworkWithCompaniesWithLegalEntitiesAndCountries[],
): CascaderOptionType[] => {
  return networkCompanyCountryYearSelector.map((networkSelector) => ({
    label: networkSelector.networkName,
    value: `${networkSelector.networkId}`,
    children: networkSelector.companies.map((companySelector) => ({
      label: companySelector.companyName,
      value: `${companySelector.companyId}`,
      children: companySelector.companyCountries.map((countrySelector) => ({
        label: countrySelector.country,
        value: countrySelector.country,
        children: countrySelector.years
          ? countrySelector.years.map((yearSelector) => ({
              label: yearSelector,
              value: `${yearSelector}`,
            }))
          : [],
      })),
    })),
  }))
}

// Note: No year here!
export const transformForAntDesignCascaderNetworkCompanyCountry = (
  networkCompanyCountryYearSelector: GroupedNetworkWithCompaniesWithLegalEntitiesAndCountries[],
): CascaderOptionType[] => {
  return networkCompanyCountryYearSelector.map((networkSelector) => ({
    label: networkSelector.networkName,
    value: `${networkSelector.networkId}`,
    children: networkSelector.companies.map((companySelector) => ({
      label: companySelector.companyName,
      value: `${companySelector.companyId}`,
      children: Array.from(new Set(companySelector.companyCountries.map((c) => c.country))).map((countrySelector) => ({
        label: countrySelector,
        value: countrySelector,
      })),
    })),
  }))
}

export interface SelectedNetworkCompanyCountryYear {
  networkId: string
  companyId: string
  country: string
  year: string
}

export const selectFirstOccurenceNetworkCompanyCountryYear = (
  networkCompanyCountryYearSelector: GroupedNetworkWithCompaniesWithLegalEntitiesAndCountries[],
): SelectedNetworkCompanyCountryYear => {
  return {
    networkId: networkCompanyCountryYearSelector[0].networkId,
    companyId: networkCompanyCountryYearSelector[0].companies[0].companyId,
    country: networkCompanyCountryYearSelector[0].companies[0].companyCountries[0].country,
    year: `${
      networkCompanyCountryYearSelector[0].companies[0].companyCountries[0].years
        ? networkCompanyCountryYearSelector[0].companies[0].companyCountries[0].years[0]
        : 0
    }`,
  }
}

export interface SelectedNetworkCompanyCountry {
  networkId: string
  companyId: string
  country: string
}

export const selectFirstOccurenceNetworkCompanyCountry = (
  networkCompanyCountryYearSelector: GroupedNetworkWithCompaniesWithLegalEntitiesAndCountries[],
): SelectedNetworkCompanyCountry => {
  return {
    networkId: networkCompanyCountryYearSelector[0].networkId,
    companyId: networkCompanyCountryYearSelector[0].companies[0].companyId,
    country: networkCompanyCountryYearSelector[0].companies[0].companyCountries[0].country,
  }
}
